import useSWR from 'swr';
import queryString from 'query-string';
import type { SwrReturnType } from '~/models/Api';
import type { ConstructionItemSettingEdit } from '~/models/ConstructionItemSetting';

const paths = {
  index: '/vendors/construction_item_settings'
};
type TIndex = (
  companyMasterId: number | null
) => SwrReturnType<ConstructionItemSettingEdit[]>;
type ReturnType = {
  index: TIndex;
};

export const useConstructionItemSettings = (): ReturnType => {
  const index: TIndex = (companyMasterId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<ConstructionItemSettingEdit[]>(
      queryString.stringifyUrl({
        url: paths.index,
        query: { company_master_id: companyMasterId }
      })
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
